/**
 * 缓存说明:关于金额的缓存
 */
import vm from '@/cache/storeTools.js'
import balanceApi from '@/components/api/money/balanceApi.js'

var basestate = {
	idToBalance: {

	},
	detailType:{
		Recharge_AliPay:"支付宝充值",
		Meter_Reading:"用电扣费",
		Recharge_WeixinPay:"微信充值",
		Siemens_Consumption:"充电扣费",
	},
	payState:{
		'0':'未付款',
		'1':'成功',
		'-1':'失败',
		'-2':'超时',
	}
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getBalance(state, getters) {
			return (targetId, type) => {
				var balance = state.idToBalance[targetId + '___' + type]
				if (balance == undefined) {
					store.commit('getBalance', {
						targetId,
						type
					})
				}
				return balance
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getBalance(state, data) {
			var targetId = data.targetId
			var type = data.type
			balanceApi.searchBalance(targetId,type,respon=>{
				vm.Vue.set(state.idToBalance,targetId+'___'+type,respon)
			})
		}

	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
